(() => {
  const controllers = new Map();
  const instances = new WeakMap();
  const activeRoots = new Set();

  function mount(scope) {
    const roots = [];
    if (scope.matches?.('[data-component]')) roots.push(scope);
    roots.push(...scope.querySelectorAll?.('[data-component]') || []);
    for (const root of roots) {
      if (instances.has(root)) continue;
      const factory = controllers.get(root.dataset.component);
      if (!factory) continue;
      const controller = factory(root);
      controller?.connect?.();
      instances.set(root, controller);
      activeRoots.add(root);
    }
  }

  function unmount(scope) {
    for (const root of activeRoots) {
      if (root === scope || scope.contains(root)) {
        instances.get(root)?.disconnect?.();
        instances.delete(root);
        activeRoots.delete(root);
      }
    }
  }

  window.Varellea = Object.freeze({
    register(name, factory) {
      controllers.set(name, factory);
      mount(document);
    },
    mount,
    unmount
  });

  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => unmount(event.target));
  document.addEventListener('shopify:section:reorder', event => {
    unmount(event.target);
    mount(event.target);
  });
  document.addEventListener('shopify:block:select', event => {
    event.target.dispatchEvent(new CustomEvent('varellea:block:select', { bubbles: true, detail: event.detail }));
  });
  document.addEventListener('shopify:block:deselect', event => {
    event.target.dispatchEvent(new CustomEvent('varellea:block:deselect', { bubbles: true, detail: event.detail }));
  });
  mount(document);
})();
